module.exports = __webpack_public_path__ + "img/edamame.3d3acf0f.gif";